import { render, staticRenderFns } from "./SkeletonListItem.vue?vue&type=template&id=7653c63a&scoped=true&"
import script from "./SkeletonListItem.vue?vue&type=script&lang=js&"
export * from "./SkeletonListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7653c63a",
  null
  
)

export default component.exports